import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Modal,
  Button,
  Tabs,
  Tab,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TextLoading from "../../global/TextLoading";

import { AttendanceForDays } from "../../../api/class";

export default function ModalConfirmAttendance(props) {
  const [t] = useTranslation(["class", "global"]);
  const [categories, setCategories] = useState(
    props.attendanceToConfirmed || [],
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleToggleContent = (catIndex, dayIndex) => {
    const updatedCategories = [...categories];
    updatedCategories[catIndex].attendancesDays[dayIndex].showContent =
      !updatedCategories[catIndex].attendancesDays[dayIndex].showContent;
    setCategories(updatedCategories);
  };

  const handleSave = () => {
    const payload = {
      class_id: props.classId,
      dates: [],
    };

    categories.forEach((category) => {
      category.attendancesDays.forEach((day) => {
        // si day.date no existe, crear nueva entrada en payload.dates
        let dateEntry = payload.dates.find((d) => d.idName === day.date);
        if (!dateEntry) {
          dateEntry = {
            idName: day.date,
            date: day.dateUnix,
            categories: [],
          };
          // si categoria no existe en dateEntry.categories, crear nueva entrada
          const categoryEntry = {
            category_attendance_id: category.id,
            type_attendance: category.type == "checkbox" ? "check" : "text",
            students: day.students.map((student) => ({
              student_id: student.id,
              value: category.type === "text" ? student.value || "" : 0,
            })),
          };
          dateEntry.categories.push(categoryEntry);
          payload.dates.push(dateEntry);
        } else {
          // si categoria no existe en dateEntry.categories, crear nueva entrada
          let categoryEntry = dateEntry.categories.find(
            (c) => c.category_attendance_id === category.id,
          );
          if (!categoryEntry) {
            categoryEntry = {
              category_attendance_id: category.id,
              type_attendance: category.type == "checkbox" ? "check" : "text",
              students: [],
            };
            dateEntry.categories.push(categoryEntry);
          }
          // agregar estudiantes a categoryEntry.students
          day.students.forEach((student) => {
            // verificar si estudiante ya existe en categoryEntry.students
            const studentEntry = categoryEntry.students.find(
              (s) => s.student_id === student.id,
            );
            if (!studentEntry) {
              categoryEntry.students.push({
                student_id: student.id,
                value: category.type === "text" ? student.value || "" : 0,
              });
            }
          });
        }
      });
    });

    confirmAttendance(payload);
  };

  const confirmAttendance = (payload) => {
    setSaving(true);
    AttendanceForDays(payload)
      .then((response) => {
        if (response.status) {
          props.updateList();
          props.onClose(true);
        } else {
          setError(response.description);
        }
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const listStudents = (day) => {
    const absentStudents = props.studentList.filter(
      (student) => !day.students.some((p) => p.id === student.id),
    );
    return absentStudents.map((student, index) => (
      <Col
        md={12}
        key={index}
        style={{
          paddingLeft: 30,
          paddingRight: 10,
        }}
      >
        {student.first_name + " " + student.last_name}
      </Col>
    ));
  };

  return (
    <Modal
      show={props.showModalConfirmAttendance}
      aria-labelledby="contained-modal-title-lg"
      id="modalConfirmAttendance"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-lg">
          {t("class:modalConfirmAttendance.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={12}>{t("class:modalConfirmAttendance.absentStudents")}</Col>
        </Row>
        <Tabs defaultActiveKey={categories[0].id} id="classStudentsTabs">
          {categories.map((category, catIndex) => (
            <Tab
              key={catIndex}
              eventKey={category.id}
              className="mb-3"
              title={
                <span style={{ display: "flex", alignItems: "center" }}>
                  {category.name}
                  <span
                    style={{
                      display: "inline-block",
                      width: 16,
                      height: 16,
                      background: "#" + (category.color || "cccccc"),
                      borderRadius: 3,
                      marginLeft: 8,
                    }}
                  ></span>
                </span>
              }
            >
              <Container>
                <Row>
                  <Col
                    xs={12}
                    className="mb-2 px-4 pt-2"
                    style={{
                      borderLeft: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      borderBottom: "1px solid #dee2e6",
                      borderTop: "none",
                      borderBottomLeftRadius: "8px",
                      borderBottomRightRadius: "8px",
                    }}
                  >
                    {/* mapear dias */}
                    {category.attendancesDays.map((day, dayIndex) => {
                      return (
                        <Row key={dayIndex}>
                          <Col
                            xs={12}
                            className="mb-2"
                            style={{
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <Row>
                              <Col md={6} style={{ padding: 10 }}>
                                <b>{day.dateDay}</b>
                              </Col>
                              <Col md={6} style={{ padding: 10 }}>
                                {day.showContent ? (
                                  <i
                                    className="bi bi-chevron-up float-end"
                                    //   id={""}
                                    role="button"
                                    onClick={() =>
                                      handleToggleContent(catIndex, dayIndex)
                                    }
                                  />
                                ) : (
                                  <i
                                    className="bi bi-chevron-down float-end"
                                    //   id={""}
                                    role="button"
                                    onClick={() =>
                                      handleToggleContent(catIndex, dayIndex)
                                    }
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className="mb-2" hidden={!day.showContent}>
                              {category.type === "checkbox" ? (
                                <>
                                  {day.students.length > 0 &&
                                    day.students.map((student, index) => (
                                      <Col
                                        md={12}
                                        key={index}
                                        style={{
                                          paddingLeft: 30,
                                          paddingRight: 10,
                                        }}
                                      >
                                        {student.first_name +
                                          " " +
                                          student.last_name}
                                      </Col>
                                    ))}

                                  {day.students.length === 0 && (
                                    <Col
                                      md={12}
                                      style={{
                                        paddingLeft: 30,
                                        paddingRight: 10,
                                      }}
                                    >
                                      {t(
                                        "class:modalConfirmAttendance.noAbsences",
                                      )}
                                    </Col>
                                  )}
                                </>
                              ) : (
                                listStudents(day)
                              )}
                            </Row>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              </Container>
            </Tab>
          ))}
        </Tabs>
        <Row className="mb-3">
          <Col md={12}>{t("class:modalConfirmAttendance.confirmMenssage")}</Col>
        </Row>
        {/** Show error message */}
        {error && (
          <Row className="mb-3">
            <Col md={12}>
              <Alert variant="warning">{error}</Alert>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          id="btnCancel"
          variant="secondary"
          onClick={props.onClose}
          disabled={saving}
        >
          {t("global:buttons.cancel")}
        </Button>
        <Button
          id="btnAccept"
          variant="primary"
          onClick={() => handleSave()}
          disabled={saving}
        >
          {saving ? (
            <TextLoading text={t("global:buttons.saving")} variant="light" />
          ) : (
            t("global:buttons.accept")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalConfirmAttendance.propTypes = {
  showModalConfirmAttendance: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  attendanceToConfirmed: PropTypes.array.isRequired,
  studentList: PropTypes.array.isRequired,
  classId: PropTypes.number.isRequired,
  updateList: PropTypes.func.isRequired,
};
